import React from 'react'

interface SelectedProps {
  label: string;
  handler: () => void;
}

const ButtonComponent: React.FC<SelectedProps> = ({label, handler}) => {
  return (
    <div className='hover:cursor-pointer'>
      <button
        type="button"
        onClick={handler}
        className='text-center px-4 py-3 md:py-2 bg-gradient-to-r from-accent-teal to-accent-deep-purple rounded-xl font-semibold text-white min-w-28 hover:opacity-90 active:opacity-80 hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 shadow-lg shadow-accent-teal/25 min-h-[44px] md:min-h-0'
      >
        {label}
      </button>
    </div>
  )
}

export default ButtonComponent
